// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"878475a8","11":"06faa62a","130":"14326a7d","178":"1fda5626","267":"8797caec","367":"12c25b3b","472":"7bfb90b8","485":"da6008ed","492":"56af2856","513":"00a9649b","605":"946303d9","709":"b0ba76e3","896":"7e369f6a"}[chunkId] + ".chunk.js";
};